import { FigureCard } from './FigureCard';
import type { Figure } from './policyFigures';

/** The policy's product, term, days left, GWP at binding, all-in cost and rate. */
export function TermAndPremiumCard({ figures }: { figures: Figure[] }) {
  return <FigureCard title="Term and premium" figures={figures} />;
}
